const filterConfig = {
  type: "object",
  properties: {
    // customer_id: {
    //     type: 'integer',
    // },
    day: {
        type: 'string',
    },
    search: {
      type: "string",
    },
  },
};
const getFiltersConfig: any = (type: string) => {
  return filterConfig;
};
export default getFiltersConfig;
